
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'DirectionsStagesTransportationEqipmentBlock',

  computed: {
    documentLink: function () {
      return `${ this.$nuxt?.context?.env?.baseApiUrl }/api/storage/file/${ this.values.memo_link }`
    }
  },

  methods: {
    leaveRequest: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: this.values?.form_type || 'Заказать звонок',
          hideTabs: true,
          miniReachGoal: this.values.reach_goal,
          fullReachGoal: this.values.reach_goal,
        }
      });
    }
  }
});
